<template>
	<AppModal
		ref="countdown-timer-modal"
		id="countdown-timer-modal"
		class="countdown-timer-modal"
		title="Add a Countdown Timer"
		class-name="block-modal fade"
		:close-button="false"
		:backdrop="false"
	>
		<div class="d-flex mb-3 d-flex flex-row mb-3 gap-15px countdown-time-picker" :key="resetKey">
			<div class="w-50">
				<AppFlatPickr
					ref="calendar"
					custom_class="form-control"
					placeholder="End Date"
					v-model="endDate"
					:min_date="minDateStart"
					@onDateSelect="onDateTimeSelected"
				/>
			</div>
			<div class="w-50">
				<div class="datetime-dropdown time">
					<AppDropdown
						class="form-control py-0"
						placeholder="End Time"
						:options="startTimeOptions"
						:searchable="false"
						label="name"
						reduce="value"
						:rightAlign="false"
						:disabled="startTimeOptions.length < 1"
						v-model="endTimeValue"
						@select="onDateTimeSelected"
					/>
				</div>
			</div>
		</div>
		<div class="d-flex flex-column gap v-gap mt-3 pt-1 col-sm">
			<AppButton name="cta-button-modal-countdown-timer-modal" @click="handleSubmit">Add Countdown Timer</AppButton>
		</div>
	</AppModal>
</template>
<script>
	import { configSettings } from '~/plugins/config-settings.js'
	import { format, parseISO, addMinutes, setSeconds, setMilliseconds, isSameDay, parse } from 'date-fns'
	import { getTimesValue, timesArray, getTimesAPIValue } from '~/pages/stores/components/BaseDefaults.js'

	export default {
		components: {},
		props: {
			editor: {
				type: Object,
				required: true,
			},
			attributes: {
				type: Object,
				default: null,
			},
		},
		data() {
			return {
				errorText: [],
				endDate: undefined,
				endTimeValue: undefined,
				resetKey: 0,
				timerOption: 'absolute',
				end_date_time: undefined,
			}
		},
		computed: {
			minDateStart() {
				return new Date()
			},
			startTimeOptions() {
				if (this.endDate) {
					const date = parseISO(this.endDate)
					const slotTime = this.getNextDateOnThe15(new Date())
					const timeValue = getTimesValue(format(slotTime, 'hh:mm a'))
					return this.getDateTimeOptions(date, new Date(), timeValue, true)
				}
				return []
			},
		},
		methods: {
			handleCancel() {
				$(this.$refs['countdown-timer-modal'].$el).modal('hide')
				this.errorText = []
			},
			getEmbedHTML() {
				const url = `${configSettings.informalApiUrl}api/v1/countdown?target=${this.end_date_time.toISOString()}`
				return `<img alt="Count down to ${this.end_date_time}" src="${url}" />`
			},
			handleSubmit() {
				if (!this.end_date_time) {
					this.errorText = ['Please enter Valid End time']
					return
				}

				const embedHTML = this.getEmbedHTML()

				if (embedHTML) {
					this.editor
						.chain()
						.focus()
						.insertContent(embedHTML)
						.run()
					this.tick += 1
					this.handleCancel()
				}
			},
			onLoad() {
				if (this.attributes) {
					this.assignForm()
				}
				this.errorText = []
				$(this.$refs['countdown-timer-modal'].$el).modal('show')
			},
			async onDateTimeSelected() {
				await this.$nextTick()

				this.end_date_time = parse(
					`${this.endDate} ${getTimesAPIValue(this.endTimeValue)}`,
					this.$constants.DATE_FORMAT.DATE_TIME_FORMAT_AM_PM,
					new Date()
				)
			},
			getNextDateOnThe15(date) {
				const minutes = date.getMinutes()
				const addMin = 15 - (minutes % 15)
				const roundedDate = addMinutes(date, addMin !== 15 ? addMin : 0)
				const nextDate = setSeconds(setMilliseconds(roundedDate, 0), 0)
				return nextDate
			},
			getDateTimeOptions(date, compareDate, timeValue, inclusive) {
				let allTimeslots = timesArray
				if (isSameDay(date, compareDate) && timeValue !== undefined) {
					allTimeslots = allTimeslots.filter(s => (inclusive ? s.value >= timeValue : s.value > timeValue))
				}
				return allTimeslots
			},
		},
	}
</script>
<style scoped>
	.countdown-timer-modal::v-deep {
		overflow: visible;

		.modal-inner-content {
			overflow: visible;
		}
	}
	.countdown-time-picker {
		padding-left: 15px;
		padding-right: 15px;
	}
</style>
